import { Injectable } from '@angular/core';
import { encodeObjectIfNeeded, decodeFabricItems } from '@pncl/common-models';
import { FabricObject } from '../sessions/session/items-canvas/board-items/board-items-manager';
import { FlagsService, FLAGS } from './flags.service';
import { TelemetryService } from './telemetry.service';

/**
 * Service for encoding and decoding scribbles and highlights using Protobuf.
 * This service centralizes the protobuf logic for better maintainability and reusability.
 */
@Injectable({ providedIn: 'root' })
export class BoardItemsEncoderDecoder {
  constructor(
    private readonly flagsService: FlagsService,
    private readonly telemetry: TelemetryService,
  ) {}

  /**
   * Encodes a scribble or highlight fabric object to a Protobuf buffer.
   * @param fabricObject The fabric object to encode
   * @returns A Uint8Array buffer containing the encoded protobuf data
   * @throws Error if protobuf is not loaded or encoding fails
   */
  public encodeObjectIfNeeded(fabricObject: FabricObject) {
    if (!this.flagsService.isFlagEnabled(FLAGS.STORE_SCRIBBLES_AS_BUFFERS)) {
      return fabricObject;
    }

    try {
      return encodeObjectIfNeeded(fabricObject);
    } catch (error) {
      this.telemetry?.errorEvent('[boardItemsEncoderDecoder] Failed to decode protobuf', {
        error: error?.message,
      });
      throw new Error('Decoding failed');
    }
  }

  public decodeFabricItems(fabricItems: FabricObject[]): FabricObject[] {
    return decodeFabricItems(fabricItems);
  }
}
